<template>
  <div class="RecordedShow">
    <div class="previous-shopping">
      <h2>{{$t('lastliveVideos')}}</h2>
      <ul class="menues">
        <li
          :class="{'active':selectedCatId == 0}"
          @click="getLiveProductsVideosByCat(0)"
        >{{$t('allVideos')}}</li>
        <li
          v-for="(category,index) in categories"
          :class="{'active':selectedCatId == category.id}"
          :key="index"
          @click="getLiveProductsVideosByCat(category.id)"
        >{{category.name}}</li>
      </ul>
      <ul class="tv_shop_listing">
        <li
          v-if="index!=0 || product.saleType!='LIVE'"
          v-for="(product,index) in productsVideos"
          :key="index"
        >
          <div class="list-item" @click="goToVideoDetail(product.saleReferenceID,'LIVE')">
            <div class="list-img">
              <div class="img_wrapper spinner_wrapper" v-lazyload v-if="product.displayImage">
                <ImageSpinner class="image_spinner" />
                <img :data-url="product.displayImage" alt />
              </div>
              <!-- <video id="myVideo" width="320" height="240" controls :src="product.itemVideoDTOList[0].original"></video> -->
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="45"
                height="34"
                viewBox="0 0 45 34"
                class="play_icon"
              >
                <g fill="none" fill-rule="nonzero">
                  <path
                    fill="red"
                    d="M43.904 27.888a5.592 5.592 0 0 1-4.704 4.48c-3.696.56-9.856 1.232-16.8 1.232-6.832 0-12.992-.672-16.8-1.232a5.592 5.592 0 0 1-4.704-4.48C.448 25.312 0 21.504 0 16.8c0-4.704.448-8.512.896-11.088A5.592 5.592 0 0 1 5.6 1.232C9.296.672 15.456 0 22.4 0c6.944 0 12.992.672 16.8 1.232a5.592 5.592 0 0 1 4.704 4.48c.448 2.576 1.008 6.384 1.008 11.088-.112 4.704-.56 8.512-1.008 11.088z"
                  />
                  <path fill="#FFF" d="M17.92 24.64V8.96l13.44 7.84z" />
                </g>
              </svg>
              <span class="new-tag">
                <!-- <img src="../assets/images/new-products-label.svg" alt /> -->
              </span>
              <span class="video-timing">
                <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8">
                  <g fill="#FFF" fill-rule="evenodd">
                    <path
                      d="M3.896 7.592a3.696 3.696 0 1 1 0-7.392 3.696 3.696 0 0 1 0 7.392zm0-.672a3.024 3.024 0 1 0 0-6.048 3.024 3.024 0 0 0 0 6.048z"
                    />
                    <path
                      d="M5.142 4.666a.336.336 0 0 1-.476.476L3.658 4.134a.336.336 0 0 1-.098-.238V1.88a.336.336 0 1 1 .672 0v1.877l.91.91z"
                    />
                  </g>
                </svg>
                {{product.displaySaleDate}}
                <!-- {{newDate(product.endTime , product.startTime)}} -->
              </span>
            </div>
            <div class="list-content">
              <p class="list-title">{{product.productName}}</p>
              <span class="sub-title">
                {{product.peopleBought}}
                {{$t('peopleHaveBrought')}}
              </span>
              <div class="list-price video-price">
                <div class="ribbon trending" v-if="product.trending">Trending</div>
                <span>₹​{{product.groupPrice}}</span>
                <strike>₹​{{product.markedPrice}}</strike>
              </div>
            </div>
          </div>
        </li>
      </ul>
      <infinite-loading
        :id="selectedCatId"
        @infinite="getLiveProductsVideos"
        spinner="circles"
        v-if="statusComplete"
      >
        <template slot="no-more">{{$t('noMoreRecord')}}</template>
      </infinite-loading>
    </div>
    <div class="cntntLoad" v-if="loading">
      <img src="../../assets/images/loader.gif" />
    </div>
  </div>
</template>
<script>
import ImageSpinner from "../Common/ImageSpinner";
import Vue from "vue";
import { bus } from "../../main";
export default {
  name: "RecordedShow",
  components: {
    ImageSpinner
  },
  data() {
    return {
      type: "LIVE",
      loading: false,
      categories: [],
      selectedCatId: 0,
      realVideoTime: "",
      productsVideos: [],
      pageIndex: 0,
      otherPageIndex: 0,
      testFlag: true,
      statusComplete: true,
      reloadData: false,
      newDataComplete: false,
      langCheck: ["hi", "en"].includes(this.$cookie.get("lang"))
    };
  },
  methods: {
    getVideoCategories() {
      this.$store
        .dispatch({
          type: "getCategoryTreeBySaleType"
        })
        .then(data => {
          this.categories = data.data.childCategories;
        })
        .catch(err => {
          let obj = {
            status: "Failure",
            timeoutMs: "5000"
          };
          bus.$emit("apiStatus", obj);
        });
    },

    goToVideoDetail(productSrId, type) {
      this.loading = true;
      var obj = {
        saleReferenceID: productSrId
      };
      this.$router.onError(err => {
        if (/loading chunk \d* failed./i.test(err.message)) {
          window.location.reload();
        }
      });
      this.$router.push("/video-detail/" + productSrId);
      this.loading = false;
    },
    getLiveProductsVideosByCat(value) {
      if (this.langCheck && this.newDataComplete) {
        this.statusComplete = false;
        this.$nextTick(() => {
          this.statusComplete = true;
          this.selectedCatId = value;
          this.pageIndex = 0;
          this.otherPageIndex = 0;
          this.productsVideos = [];
          this.testFlag = true;
          this.reloadData = false;
        });
      } else {
        this.statusComplete = false;
        this.$nextTick(() => {
          this.statusComplete = true;
          this.selectedCatId = value;
          this.pageIndex = 0;
          this.otherPageIndex = 0;
          this.productsVideos = [];
          this.testFlag = true;
          this.reloadData = false;
        });
      }
    },
    async getLiveProductsVideos($state) {
      this.cntntLoad = true;
      if (this.testFlag) {
        const obj = {
          categoryId: this.selectedCatId,
          pageIndex: this.pageIndex,
          saleType: this.type
        };
        // console.log(obj);
        await this.$store
          .dispatch({
            type: "getSalesListing",
            payload: obj
          })
          .then(data => {
            this.cntntLoad = false;
            if (data.data.saleProductDTOs.length > 0) {
              this.pageIndex += 1;
              this.productsVideos.push(...data.data.saleProductDTOs);
              $state && $state.loaded();
            } else {
              this.testFlag = false;
              if (this.langCheck) {
                $state && $state.complete();
                this.newDataComplete = true;
              }
            }
          })
          .catch(err => {
            this.cntntLoad = false;
            this.toasterData = {
              msg: "No Data Found",
              color: "red"
            };
            this.isCommentLength = true;
          });
      }
      if (!this.testFlag && !this.reloadData) {
        const obj = {
          categoryId: this.selectedCatId,
          pageIndex: 0,
          saleType: this.type,
          otherLangPageIndex: this.otherPageIndex
        };
        // console.log(obj);
        this.$store
          .dispatch({
            type: "getSalesListing",
            payload: obj
          })
          .then(data => {
            if (data.data.saleProductDTOs.length > 0) {
              this.otherPageIndex += 1;
              this.productsVideos.push(...data.data.saleProductDTOs);
              $state && $state.loaded();
            } else {
              this.pageIndex = -1;
              this.otherPageIndex = -1;
              $state && $state.complete();
              // this.reloadData = true;
              // if (!this.langCheck) {
              //   this.forceRerender();
              // }
            }
          })
          .catch(err => {
            this.cntntLoad = false;
            this.toasterData = {
              msg: "No Data Found",
              color: "red"
            };
            this.isCommentLength = true;
          });
      }
      if (this.reloadData) {
        const obj = {
          categoryId: this.selectedCatId,
          pageIndex: 0,
          saleType: this.type,
          otherLangPageIndex: this.otherPageIndex
        };
        // console.log(obj);
        this.$store
          .dispatch({
            type: "getSalesListing",
            payload: obj
          })
          .then(data => {
            if (data.data.saleProductDTOs.length > 0) {
              this.otherPageIndex += 1;
              this.productsVideos.push(...data.data.saleProductDTOs);
              $state && $state.loaded();
            } else {
              $state && $state.complete();
              // this.reloadData = true;
              // if (!this.langCheck) {
              //   this.forceRerender();
              // }
            }
          })
          .catch(err => {
            this.cntntLoad = false;
            this.toasterData = {
              msg: "No Data Found",
              color: "red"
            };
            this.isCommentLength = true;
          });
      }
    },
    forceRerender() {
      this.statusComplete = false;
      this.$nextTick(() => {
        this.pageIndex = 0;
        this.otherPageIndex = 0;
        this.productsVideos = [];
        this.testFlag = true;
        this.reloadData = true;
        this.statusComplete = true;
      });
    },
    newDate(val1, val2) {
      const timeStart = Number(val1);
      const timeEnd = Number(val2);
      var hourDiff;
      if (timeStart > timeEnd) {
        hourDiff = (timeStart - timeEnd) / 1000;
      } else {
        hourDiff = (timeEnd - timeStart) / 1000;
      }
    }
  },
  mounted() {
    this.getVideoCategories();
    // if (this.$store.getters.productsVideos.length > 0) {
    //   this.productsVideos = this.$store.getters.productsVideos;
    //   this.pageIndex = this.$store.getters.pageIndex;
    // } else {
    //   // this.getLiveProductsVideos();
    // }
  }
};
</script>
